var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-min-w-0 tw-shrink-0 tw-grow-0 tw-basis-full tw-pl-4",attrs:{"role":"group","aria-roledescription":"slide"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }